import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import Hotlinks from 'src/components/menu/Hotlinks';
import PromoLinksKgk from 'src/components/menu/PromoLinksKgk';
import SearchAndDropdownMenu from 'src/components/menu/SearchAndDropdownMenu';
import FilmwebLogoSvg from 'src/components/svg/FilmwebLogoSvg';
import ISettings from 'src/lib/types/Settings';
import styles from './Menu.module.css';

//#region [Props]
type MenuProps = {
	settings: ISettings;
};
//#endregion

//#region [Component]
export default function Menu({ settings }: MenuProps) {
	return <nav className={styles.SMenuWrapper}>
		<FilmwebLink to='/' title='Til forsiden' className={styles.SLogoLink}>
			<FilmwebLogoSvg />
		</FilmwebLink>
		<Hotlinks hotlinks={settings?.hotlinks}/>
		<PromoLinksKgk settings={settings}/>
		<SearchAndDropdownMenu menuData={settings?.mainMenu}/>
	</nav>;
}
//#endregion

//#region [Styles]
// Converted to CSS Modules (Menu.module.css) preserving SMenuWrapper and SLogoLink
//#endregion
